export enum sourceTypesEnum {
  CONNECTION = 'connection',
  AUDIENCE = 'audience',
  SYNC = 'sync',
  WEBHOOK = 'webhook',
}
